<template>
  <div>
    <b-carousel id="carousel" controls indicators background="#FFF" v-if="result.images.length">
      <b-carousel-slide v-for="(image, imageIndex) in result.images" :key="imageIndex">
        <template slot="img">
          <img :src="image" class="img-fluid w-100 d-block carousel-img" />
        </template>
      </b-carousel-slide>
    </b-carousel>
    <template v-else>
      <img v-if="result.image" :src="result.image" class="img-fluid" />
      <img v-else src="@/assets/images/backgrounds/default-image.jpg" class="img-fluid" />
    </template>
  </div>
</template>

<script>
export default {
  name: 'Carousel',
  props: {
    result: {
      type: Object,
      mandatory: true
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
